import { render, staticRenderFns } from "./CustomersViewSidebar.vue?vue&type=template&id=692f0f60&scoped=true"
import script from "./CustomersViewSidebar.vue?vue&type=script&lang=js"
export * from "./CustomersViewSidebar.vue?vue&type=script&lang=js"
import style0 from "./CustomersViewSidebar.vue?vue&type=style&index=0&id=692f0f60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692f0f60",
  null
  
)

export default component.exports